<div class="popup-comp">
  <div class="modal-header">
    <h4 class="modal-title" id="sanofiModalLabel" ngbAutofocus>
      {{ popup_title }}
    </h4>
  </div>

  <div class="modal-body">
    <p [innerHTML]="popup_content"></p>
  </div>

  <div class="modal-footer">
    <div class="undo-changes-btngrps">
      <button id="proceedExPopup" type="button" class="btn-primary w-100" (click)="goToExternalSite(externalUrl)">
        Proceed
      </button>
      <button type="button" class="btn-secondary w-100 mt-3" (click)="activeModal.close('close click')">
        Close
      </button>
    </div>
  </div>
</div>